import '/components/person-teaser/person-teaser.scss';
